module.exports = {
      id: "mailbox-usage",
      viewBox: "0 0 16 11",
      url: __webpack_public_path__ + "img/icons.91580017.svg#mailbox-usage",
      toString: function () {
        return this.url;
      }
    }